import ApiGateway from "../../explorer/services/ApiGateway";
import { BasketService } from "../../explorer/services/BasketService";
import { BasketUploadData, BasketUploadInfo, BasketUploadResult } from "../../explorer/types/Basket/BasketUploadPartInfo";
import { endpoints } from "../configuration/endpoints";

export class CustomBasketService extends BasketService {
    public checkItemsForBasketUpload = (
        brand: string,
        lang:string,
        parts: string[]
    ): Promise<BasketUploadInfo> => {
        return new Promise<any>((resolve, reject) => {
            ApiGateway()
                .post<any>(
                    endpoints.basket.checkItemsForUpload.replace(
                        "{brand}",
                        brand
                    ) +
                        "?lang=" +
                        lang,
                    {
                        itemsCode: parts,
                    }
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };

    public uploadBasket = (
        brand: string,
        data: BasketUploadData
    ): Promise<BasketUploadResult> => {
        return new Promise<any>((resolve, reject) => {
            ApiGateway()
                .post<BasketUploadData>(
                    endpoints.basket.uploadBasket.replace("{brand}", brand),
                    data
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };

    public uploadBasketSendReport = (
        brand: string,
        uploadType: string,
        data: any,
        progressCallback?: any
    ): Promise<any> => {
        return new Promise<any>((resolve, reject) => {
            const formData = new FormData();
            formData.append("uploadedFile", data);
            ApiGateway()
                .post<any>(
                    endpoints.basket.uploadBasketSendReport.replace(
                        "{brand}",
                        brand
                    ),
                    formData,
                    {
                        headers: { "Content-Type": "multipart/form-data" },
                        onUploadProgress: (ProgressEvent) => {
                            if (progressCallback)
                                progressCallback(ProgressEvent);
                        },
                    }
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };
    public checkBasketName = (brand:string, name: string): Promise<any> => {
        return new Promise<any>((resolve, reject) => {
            ApiGateway()
                .post<any>(endpoints.basket.checkBasketName.replace(
                        "{brand}",
                        brand
                    ), {
                    name: name,
                })
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };
    
}
